import { render } from "./rangeslider.vue?vue&type=template&id=1f1a0b2c"
import script from "./rangeslider.vue?vue&type=script&lang=js"
export * from "./rangeslider.vue?vue&type=script&lang=js"

import "./rangeslider.vue?vue&type=style&index=0&id=1f1a0b2c&lang=css"
import "@vueform/slider/themes/default.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__